@if (!isFetching) {
    <a class="hotel {{hotelData.class}}"
       target="_blank"
       href="{{hotelData.providerURL || hotelData.url}}"
       (click)="trackAndRedirect($event, hotelData.providerURL || hotelData.url)">
        <div class="f-row">
            <div class="hotel--img" [style.background-image]="'url(' + hotelData?.image?.ThumbnailUrl + ')'">
            </div>
            <div class="hotel-information">
                <h5 class="hotel-information--title">{{ hotelData.name }}</h5>
                <div class="f-row f-v-center hotel-information-rating">
                    <p class="hotel-information-rating--score">
                        {{ hotelData.rating.average }}
                    </p>
                    <div class="hotel-information-rating-star">
                        @for (start of hotelData.stars | generateStarData; track $index) {
                            <mat-icon [svgIcon]="eSvgIcons.HOTEL_STAR"></mat-icon>
                        }
                    </div>
                </div>
                @if (hotelData.mealPlan === "breakfast_included") {
                    <p class="hotel-information--desc">Breakfast included</p>
                }
                @if (hotelData.cancellation | hotelCancellationTransformer) {
                    <p class="hotel-information--desc">Free cancellation</p>
                }
            </div>
        </div>
        <div class="f-row f-center f-v-center hotel-price">
            @if (hotelData.price) {
                <p class="hotel-price--value">From <span>
          {{ hotelData.price.currency === "EUR" ? "&#8364;" : "&#36;" }}{{ hotelData.price | hotelPriceTransformer }}</span>
                </p>
            }
            <a class="hotel-price--link"
               target="_blank"
               href="{{hotelData.providerURL || hotelData.url}}"
               (click)="trackAndRedirect($event, hotelData.providerURL || hotelData.url)">
                See availability >
            </a>
        </div>
        <button class="btn-hurt btn-hurt--circle"
                [class.active]="favoritesProviderService.isFavorite('booking.com', hotelData.id)"
                (click)="toggleHurt($event, hotelData)">
            <mat-icon [svgIcon]="eSvgIcons.HURT"></mat-icon>
        </button>
    </a>
} @else {
    <ngx-skeleton-loader [theme]="{height: '100%', width: '420px', borderRadius: '12px'}"></ngx-skeleton-loader>
}
